"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INSTALLMENTS_COMPLETE = exports.INSTALLMENTS_APPLICATION_DENIED = exports.INSTALLMENTS_APPLICATION_APPROVED = exports.INSTALLMENT_PAYMENT_MISSED = exports.INSTALLMENT_PAYMENT_MADE = exports.INSTALLMENT_PAYMENT_DUE = exports.HEARING_SHOW_CAUSE = exports.HEARING_REAFFIRMATION = exports.HEARING_ON_FEE_WAIVER = exports.HEARING_MINUTES = exports.HEARING_LIFT_STAY = exports.HEARING_DISMISSAL = exports.FILING_FEE_PAID = exports.FILED_UPSOLVE_LETTER = exports.FILED_TAX_RETURNS = exports.FILED_STATEMENT_OF_FINANCIAL_AFFAIRS = exports.FILED_STATEMENT_OF_MONTHLY_INCOME = exports.FILED_STATEMENT_OF_INTENT = exports.FILED_STATEMENT_ASSETS_LIABILITIES = exports.FILED_SOCIAL_SECURITY_FORM = exports.FILED_REAFFIRMATION = exports.FILED_PROPOSED_ABANDONMENT = exports.FILED_PRO_SE_QUESTIONNAIRE = exports.FILED_PROOF_OF_ID = exports.FILED_PETITION = exports.FILED_INSTALLMENTS_APPLICATION = exports.FILED_PAY_ADVICES = exports.FILED_FEE_WAIVER_APPLICATION = exports.FILED_DECLARATION_OF_SCHEDULES = exports.FILED_CREDITOR_MATRIX = exports.FILED_COURSE_TWO = exports.FILED_COURSE_ONE = exports.FILED_BANKRUPTCY_COVER_SHEET = exports.FILED_AMENDMENT = exports.FILED_ADVERSARY_PROCEEDING = exports.FEE_WAIVER_DENIED = exports.FEE_WAIVER_APPROVED = exports.ELECTRONIC_FILING = exports.DISREGARD = exports.DEFICIENCY = exports.CREDITOR_REQUEST_NOTICE = exports.CREDITOR_NOTICES_DELIVERED = exports.CHANGE_OF_CREDITOR_ADDRESS = exports.CERTIFICATE_OF_SERVICE = exports.CERTIFICATE_OF_MAILING = exports.CASE_TRANSFERRED = exports.CASE_REINSTATED = exports.CASE_DISMISSED = exports.CASE_CLOSED = exports.ASSETS_DISCOVERED = void 0;
exports.VACATE_DISMISSAL = exports.TRUSTEE_REPORT_NO_DISTRIBUTION = exports.TRUSTEE_REPORT_FOUND_ASSET_DISTRIBUTION = exports.TRUSTEE_FEE = exports.TRUSTEE_ADDED = exports.RESPONSE_PROPOSED_ABANDONMENT = exports.RECEIPT_PAYMENT = exports.RECEIPT_LIFT_STAY = exports.REAFFIRMATION_DENIED = exports.REAFFIRMATION_APPROVED = exports.PROOF_OF_CLAIM_DUE = exports.PRIOR_BK_FILING = exports.ORDER_SHOW_CAUSE = exports.ORDER_OF_DISCHARGE = exports.OBJECTION_TO_MOTION_TO_DISMISS = exports.OBJECTION_TIME_EXTENSION = exports.NOTICE_PRO_SE = exports.NOTICE_GENERAL = exports.MOTION_TO_EXTEND_DEADLINE_NO_OBJECTION = exports.MOTION_TO_EXTEND_DEADLINE = exports.MOTION_TO_DISMISS = exports.MOTION_PRO_HAC_VICE = exports.MEETING_CREDITORS_RESCHEDULED = exports.MEETING_CREDITORS_SCHEDULED = exports.MEETING_CREDITORS_ATTENDED = exports.MEETING_ADJOURNED = exports.MAIL_UNDELIVERABLE = exports.LIFT_STAY_MOTION = exports.INSTALLMENTS_ORDERED = void 0; // V4

exports.ASSETS_DISCOVERED = "assetsDiscovered";
exports.CASE_CLOSED = "caseClosed";
exports.CASE_DISMISSED = "caseDismissed";
exports.CASE_REINSTATED = "caseReinstated";
exports.CASE_TRANSFERRED = "caseTransferred";
exports.CERTIFICATE_OF_MAILING = "certificateOfMailing";
exports.CERTIFICATE_OF_SERVICE = "certificateOfService";
exports.CHANGE_OF_CREDITOR_ADDRESS = "changeOfCreditorAddress";
exports.CREDITOR_NOTICES_DELIVERED = "creditorNoticesDelivered";
exports.CREDITOR_REQUEST_NOTICE = "creditorRequestNotice";
exports.DEFICIENCY = "deficiency"; // Trying general tag instead of specifics
// export const DEFICIENCY_COURSE_ONE_CERTIFICATE = 'deficiencyCourseOneCertificate';
// export const DEFICIENCY_COURSE_TWO_CERTIFICATE = 'deficiencyCourseTwoCertificate';
// export const DEFICIENCY_DEADLINES = 'deficiencyDeadlines';
// export const DEFICIENCY_PAY_STUBS = 'deficiencyPayStubs';
// export const DEFICIENCY_SIGNATURE = 'deficiencySignature';
// export const DEFICIENCY_TAX_RETURNS = 'deficiencyTaxReturns';

exports.DISREGARD = "disregard"; // Extra label for signifying irrelevant information

exports.ELECTRONIC_FILING = "electronicFiling";
exports.FEE_WAIVER_APPROVED = "feeWaiverApproved";
exports.FEE_WAIVER_DENIED = "feeWaiverDenied";
exports.FILED_ADVERSARY_PROCEEDING = "filedAdversaryProceeding";
exports.FILED_AMENDMENT = "filedAmendment";
exports.FILED_BANKRUPTCY_COVER_SHEET = "filedBankruptcyCoverSheet";
exports.FILED_COURSE_ONE = "filedCourseOne";
exports.FILED_COURSE_TWO = "filedCourseTwo";
exports.FILED_CREDITOR_MATRIX = "filedCreditorMatrix";
exports.FILED_DECLARATION_OF_SCHEDULES = "filedDeclarationOfSchedules";
exports.FILED_FEE_WAIVER_APPLICATION = "filedFeeWaiverApplication";
exports.FILED_PAY_ADVICES = "filedPayAdvices";
exports.FILED_INSTALLMENTS_APPLICATION = "filedInstallmentsApplication";
exports.FILED_PETITION = "filedPetition";
exports.FILED_PROOF_OF_ID = "filedProofOfId";
exports.FILED_PRO_SE_QUESTIONNAIRE = "filedProSeQuestionnaire";
exports.FILED_PROPOSED_ABANDONMENT = "filedProposedAbandonment";
exports.FILED_REAFFIRMATION = "filedReaffirmation";
exports.FILED_SOCIAL_SECURITY_FORM = "filedSocialSecurityForm";
exports.FILED_STATEMENT_ASSETS_LIABILITIES = "filedStatementAssetsLiabilities";
exports.FILED_STATEMENT_OF_INTENT = "filedStatementOfIntent";
exports.FILED_STATEMENT_OF_MONTHLY_INCOME = "filedStatementOfMonthlyIncome";
exports.FILED_STATEMENT_OF_FINANCIAL_AFFAIRS = "filedStatementOfFinancialAffairs";
exports.FILED_TAX_RETURNS = "filedTaxReturns";
exports.FILED_UPSOLVE_LETTER = "filedUpsolveLetter";
exports.FILING_FEE_PAID = "filingFeePaid";
exports.HEARING_DISMISSAL = "hearingDismissal";
exports.HEARING_LIFT_STAY = "hearingLiftStay";
exports.HEARING_MINUTES = "hearingMinutes";
exports.HEARING_ON_FEE_WAIVER = "hearingOnFeeWaiver";
exports.HEARING_REAFFIRMATION = "hearingReaffirmation";
exports.HEARING_SHOW_CAUSE = "hearingShowCause";
exports.INSTALLMENT_PAYMENT_DUE = "installmentPaymentDue";
exports.INSTALLMENT_PAYMENT_MADE = "installmentPaymentMade";
exports.INSTALLMENT_PAYMENT_MISSED = "installmentPaymentMissed";
exports.INSTALLMENTS_APPLICATION_APPROVED = "installmentsApplicationApproved";
exports.INSTALLMENTS_APPLICATION_DENIED = "installmentsApplicationDenied";
exports.INSTALLMENTS_COMPLETE = "installmentsComplete";
exports.INSTALLMENTS_ORDERED = "installmentsOrdered";
exports.LIFT_STAY_MOTION = "liftStayMotion";
exports.MAIL_UNDELIVERABLE = "mailUndeliverable";
exports.MEETING_ADJOURNED = "meetingAdjourned";
exports.MEETING_CREDITORS_ATTENDED = "meetingCreditorsAttended";
exports.MEETING_CREDITORS_SCHEDULED = "meetingCreditorsScheduled";
exports.MEETING_CREDITORS_RESCHEDULED = "meetingCreditorsRescheduled";
exports.MOTION_PRO_HAC_VICE = "motionProHacVice";
exports.MOTION_TO_DISMISS = "motionToDismiss";
exports.MOTION_TO_EXTEND_DEADLINE = "motionToExtendDeadline";
exports.MOTION_TO_EXTEND_DEADLINE_NO_OBJECTION = "motionToExtendDeadlineNoObjection";
exports.NOTICE_GENERAL = "noticeGeneral";
exports.NOTICE_PRO_SE = "noticeProSe";
exports.OBJECTION_TIME_EXTENSION = "objectionTimeExtension";
exports.OBJECTION_TO_MOTION_TO_DISMISS = "objectionToMotionToDismiss";
exports.ORDER_OF_DISCHARGE = "orderOfDischarge";
exports.ORDER_SHOW_CAUSE = "orderShowCause";
exports.PRIOR_BK_FILING = "priorBkFiling";
exports.PROOF_OF_CLAIM_DUE = "proofOfClaimDue";
exports.REAFFIRMATION_APPROVED = "reaffirmationApproved";
exports.REAFFIRMATION_DENIED = "reaffirmationDenied";
exports.RECEIPT_LIFT_STAY = "receiptLiftStay";
exports.RECEIPT_PAYMENT = "receiptPayment";
exports.RESPONSE_PROPOSED_ABANDONMENT = "responseProposedAbandonment";
exports.TRUSTEE_ADDED = "trusteeAdded";
exports.TRUSTEE_FEE = "trusteeFee";
exports.TRUSTEE_REPORT_FOUND_ASSET_DISTRIBUTION = "trusteeReportFoundAssetDistribution";
exports.TRUSTEE_REPORT_NO_DISTRIBUTION = "trusteeReportNoDistribution";
exports.VACATE_DISMISSAL = "vacateDismissal";